"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCardUsedInVariantSuggestionRequest = instanceOfCardUsedInVariantSuggestionRequest;
exports.CardUsedInVariantSuggestionRequestFromJSON = CardUsedInVariantSuggestionRequestFromJSON;
exports.CardUsedInVariantSuggestionRequestFromJSONTyped = CardUsedInVariantSuggestionRequestFromJSONTyped;
exports.CardUsedInVariantSuggestionRequestToJSON = CardUsedInVariantSuggestionRequestToJSON;
exports.CardUsedInVariantSuggestionRequestToJSONTyped = CardUsedInVariantSuggestionRequestToJSONTyped;
const zoneLocationsEnum_1 = require("./zoneLocationsEnum");
/**
 * Check if a given object implements the CardUsedInVariantSuggestionRequest interface.
 */
function instanceOfCardUsedInVariantSuggestionRequest(value) {
    if (!('card' in value) || value['card'] === undefined)
        return false;
    if (!('zoneLocations' in value) || value['zoneLocations'] === undefined)
        return false;
    return true;
}
function CardUsedInVariantSuggestionRequestFromJSON(json) {
    return CardUsedInVariantSuggestionRequestFromJSONTyped(json, false);
}
function CardUsedInVariantSuggestionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'card': json['card'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'zoneLocations': (json['zoneLocations'].map(zoneLocationsEnum_1.ZoneLocationsEnumFromJSON)),
        'battlefieldCardState': json['battlefieldCardState'] == null ? undefined : json['battlefieldCardState'],
        'exileCardState': json['exileCardState'] == null ? undefined : json['exileCardState'],
        'libraryCardState': json['libraryCardState'] == null ? undefined : json['libraryCardState'],
        'graveyardCardState': json['graveyardCardState'] == null ? undefined : json['graveyardCardState'],
        'mustBeCommander': json['mustBeCommander'] == null ? undefined : json['mustBeCommander'],
    };
}
function CardUsedInVariantSuggestionRequestToJSON(json) {
    return CardUsedInVariantSuggestionRequestToJSONTyped(json, false);
}
function CardUsedInVariantSuggestionRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'card': value['card'],
        'quantity': value['quantity'],
        'zoneLocations': (value['zoneLocations'].map(zoneLocationsEnum_1.ZoneLocationsEnumToJSON)),
        'battlefieldCardState': value['battlefieldCardState'],
        'exileCardState': value['exileCardState'],
        'libraryCardState': value['libraryCardState'],
        'graveyardCardState': value['graveyardCardState'],
        'mustBeCommander': value['mustBeCommander'],
    };
}
//# sourceMappingURL=cardUsedInVariantSuggestionRequest.js.map